import { SPColor } from "../../constants/color";

export const homeClasses = {
  card: {
    position: "relative",
    display: "flex",
    flexWrap: "wrap",
    alignContent: "flex-start",
    flexDirection: "column",
    alignItems: "center",
    marginTop: "100px",
    marginLeft: "auto",
    marginRight: "auto",
  },
  container: {
    // backgroundImage: 'url("/images/home-banner950.jpg")',
    backgroundPosition: "center center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    width: "100%",
    maxWidth: "none !important",
    margin: "0 !important",
    transition:
      "background 0.3s, border 0.3s, border-radius 0.3s, box-shadow 0.3s",
    height: "92vh",
    zIndex: "-1",
    top: "0",
    display: "flex",
    marginTop: "-125px !important",
  },
  bannerBody: {
    maxWidth: "xl",
    textAlign: "center",
    paddingTop: 0,
    margin: "auto",
  },
  banner: {
    backgroundPosition: "center center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    width: "100%",
    maxWidth: "none !important",
    transition:
      "background 0.3s, border 0.3s, border-radius 0.3s, box-shadow 0.3s",
    height: { md: "300px", xs: "260px" },
    zIndex: "-1",
    top: "0",
  },
  cardList: {
    display: "flex",
    justifyContent: "center",
  },
  activeCard: {
    border: "solid 3px " + SPColor.WHITE,
  },
  miniCard: {
    width: "110px",
  },
};
